import { connect } from 'react-redux';
import Recipe from "./Recipe";

import { fetchRecipe, insertRecipeView } from '../service/recipes';
import { fetchCommentsByRecipe } from '../service/comments';
import { recipeReceived, recipeCleared, recipeCommentsReceived } from '../store';

const mapStateToProps = (state) => ({
    recipe: state.recipe
});

const mapDispatchToProps = dispatch => ({
    loadRecipe: label => (
        fetchRecipe(label)
            .then(list => {
                const article = list.article[0];
                if (article) {
                    dispatch(recipeReceived(list.article[0]));
                    insertRecipeView(list.article[0].id).then(() => {
                        fetchCommentsByRecipe(list.article[0].label)
                            .then(list => {
                                dispatch(recipeCommentsReceived(list.comments, list.totalComments));
                            })
                            .catch(e => {
                                console.error(e);
                                return false;
                            });
                    });
                } else {
                    dispatch(recipeReceived({'error': true}));
                }
                return true;
            })
            .catch(e => {
                console.error(e);
                return false;
            })
    ),
    clearRecipe: () => dispatch(recipeCleared())
});

const enhance = connect(mapStateToProps, mapDispatchToProps);

export default enhance(Recipe);



// WEBPACK FOOTER //
// ./src/components/Recipe.container.js